/*
 * @Description: 短信签名备案
 * @Author: hujingyang
 * @LastEditors: yang chenglin
 */

import React, { useEffect, useState } from 'react';
import { Button, Dialog, Icon, Input, Loading, Message, Table,Balloon } from '@alifd/next';
import moment from 'moment';
import LzPagination from '@/components/common/LzPagination';
import LzMsg from '@/components/common/LzMessage';
import BindTelPhone from '@/components/BindTelPhone';
import { Servlets } from '@/service';
import style from './index.module.scss';

/** 短信签名备案 */
const SMSSign = (): JSX.Element => {
  const [isLoading, setLoading] = useState(false);// 是否正在加载页面数据
  const [isLoadingForList, setLoadingForList] = useState(false);// 是否正在加载列表数据
  const [dataSource, setDataSource] = useState([{}]);// 列表数据
  // const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 10, total: 0 }); // 分页数据

  const [visibleDialog, setVisibleDialog] = useState(false); // 是否打开绑定手机号弹窗
  const [smsSignBeforeConfirm, setSmsSignBeforeConfirm] = useState('');
  const [updateSmsSignDialog, setUpdateSmsSignDialog] = useState(false); // 修改短信签名弹框

  /** 获取列表数据 */
  const getListData = (): void => {
    setLoading(true);
    Servlets('getSmssignlog', {}, true)
      .then((res) => {
        if(res.success) {
          setLoading(false); // 关闭loading

          setDataSource(res.data ? res.data : []); // 获取列表数据

          // setPageInfo(res.page ? res.page : pageInfo);// 设置分页

        } else {
          setLoading(false); // 关闭loading
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);/** 关闭loading */
      });
  };

  /**
   * 翻页方法
   */
  // const handlePageSizeChange = (pages: any) => {
  //   setPageInfo({ ...pageInfo, ...pages });
  //   getListData(pages);
  // };

  /**  打开生成短链接弹窗 */
  const handleOpenChangeBindTelDialog = (): void => {
    setVisibleDialog(true);
  };

  // 设为默认签名
  const useThisSign = (id) => {
    Servlets('setDefaultSign', {id}, true)
      .then((res) => {
        if(res.success) {
          getListData();
        } else {
          setLoading(false); // 关闭loading
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);/** 关闭loading */
      });
  }


  /** 初始化函数 */
  const init = (): void => {
    getListData();
  };
  /** 生命周期函数 */
  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <Loading visible={isLoading} fullScreen>
        {
          <div className={style.SMSSign}>
            <div className={style.pageInfoNotice}>
              <div>
                {/* 21年8月，应对抖音官方调整，暂时下线功能 */}
                {/* <p>1.若商家之前从未创建过短信签名，软件会自动创建与商家店铺名称相同的签名，无需人工审核。</p>
                <p>2.每个店铺只能有一个生效中的签名，商家可重新申请签名，但是新签名生效后，之前的店铺签名作废；</p>
                <p>3.如果有短信营销任务等待发送，请务必不要更换签名， 否则可能会因签名不一致导致之前的短信任务执行失败或字数计算有误。</p> */}
                <p>1.若商家之前从未创建过短信签名，软件会自动创建与商家店铺名称相同的签名，无需人工审核。</p>
                <p>2.每个店铺只能有一个生效中的签名。</p>
              </div>
            </div>
            <div className={style.mainBox}>
            <Button
              type="primary"
              onClick={() => setUpdateSmsSignDialog(true)}
              style={{ marginBottom: '10px' }}
            >新建签名
            </Button>
              <div className={style.signActive}>
                {/* 21年8月，应对抖音官方调整，暂时下线功能 */}
                {/* <div>
                  <Button type="primary" className={style.submitBtnStyle_width} onClick={()=>{setUpdateSmsSignDialog(true)}}>修改签名</Button>&emsp;&emsp;
                    <Button type="normal" className={style.submitBtnStyle_width} onClick={handleOpenChangeBindTelDialog}>修改手机号</Button>
                </div> */}

              </div>

              {/* 21年8月，应对抖音官方调整，暂时下线功能 */}
              <div className={style.formAndListStyle}>
                <div className={style.listContent}>
                  <div>
                    <Table dataSource={dataSource} fixedHeader maxBodyHeight={460} loading={isLoadingForList} >
                      <Table.Column title="短信签名" dataIndex="smsSign" align='left' cell={(value: number, index: number, record: object) => {
                        return <div>
                          {value} <span style={{color: '#3399ff'}}>{record.isDefault == 1 ? '默认' : ''}</span>
                        </div>
                      }} />
                      <Table.Column title="申请时间" dataIndex="createTime" align='left' cell={(value: number, index: number, record: object) => {
                        return <div>
                          {value ? moment((value)).format('YYYY-MM-DD HH:mm:ss') : '/'}
                        </div>
                      }} />
                      <Table.Column title="审核时间" dataIndex="createTime" align='left' cell={(value: number, index: number, record: object) => {
                        return <div>
                          {value ? moment((value)).format('YYYY-MM-DD HH:mm:ss') : '/'}
                        </div>
                      }} />
                      <Table.Column title="签名状态" dataIndex="auditStatus" align='left'
                        cell={(value: number, index: number, record: object) => {
                          if(record.auditStatus === 1) {
                            return (<div style={{ color: "#0b6" }}>待审核</div>)
                          }else if(record.auditStatus === 2) {
                            return (<div style={{ color: "#FF9900" }}>审核通过</div>)
                          }else if(record.auditStatus === 4) {
                            return (<div style={{ color: "#C3CBD6" }}>历史签名（已失效）</div>)
                          }  else if(record.auditStatus === 3) {
                            return (
                              <Balloon.Tooltip
                                align="t"
                                closable={false}
                                trigger={
                                  <div style={{display:'flex',alignItems:'center'}}>
                                    <div style={{ color: "#C3CBD6" }} >审核拒绝</div>
                                    <span
                                      style={{
                                        fontSize: '16px',
                                        marginLeft: '4px',
                                        cursor: 'pointer',
                                      }}
                                      className="iconfont icon-icon4-33"
                                    />
                                  </div>
                                }
                              >
                                <div>
                                  {record.remark? record.remark : ''}
                                </div>
                              </Balloon.Tooltip>
                            )
                          }
                        }}/>
                        <Table.Column
                          width="240px"
                          title="操作"
                          align="left"
                          lock="right"
                          cell={(value, index, record) => (
                            <div>
                              {/* 只有审核通过的才能使用 */}
                              <Button
                                type="primary"
                                text
                                disabled={record.isDefault == 1 || record.auditStatus !== 2}
                                onClick={() => useThisSign(record.id)}
                                style={{ marginLeft: '10px' }}
                              >使用该签名
                              </Button>
                            </div>
                          )}
                        />
                    </Table>
                  </div>

                  {/* {
                    !!dataSource.length && <div attr-intro="分页组件" className={[style.Pagination, 'Hjy-Pagination'].join(" ")}><LzPagination pageInfo={pageInfo} onChange={handlePageSizeChange} /></div>
                  } */}
                </div>
              </div>
            </div>


            {
                visibleDialog && <BindTelPhone
                visible={visibleDialog}
                selected={(visibleDialog: boolean) => {
                  setVisibleDialog(visibleDialog);
                }}
              />
            }
            <Dialog
              title="短信签名申请信息"
              visible={updateSmsSignDialog}
              footer={false}
              // height={"669px"}
              style={{
                width: `${758 }px`,
                overflowY: 'auto',
              }}
              isFullScreen
              onClose={() => {
                setUpdateSmsSignDialog(false);
                setSmsSignBeforeConfirm('');
              }}
            >
              <div>
                <div style={{ display: 'flex' }}>
                  <Icon type="prompt" size="small" style={{ color: '#f0b447', marginRight: 8 }} />
                  <div>
                    <p>1.字数在3-23个字符，建议使用店铺/品牌名称。签名字数计入短信字数，所以能省则省几个字</p>
                    <p>2.短信签名申请提交后，1个工作日左右完成审核</p>
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: '20px' }}>
                  <span style={{ lineHeight: '30px' }}>发送短信时唯一签名：</span>

                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Input
                      trim
                      minLength={3}
                      maxLength={23}
                      value={smsSignBeforeConfirm}
                      onChange={(val) => {
                        setSmsSignBeforeConfirm(val);
                      }}
                      hasLimitHint
                      style={{ width: 380, marginBottom: '4px' }}
                    />
                    <p>建议使用店铺名称，且不包含“抖音”和特殊符号“【”、“】”字样</p>
                    {/* <Button type="primary" text style={{ textAlign: 'left' }}>短信发送使用教程</Button> */}
                  </div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <Button
                    className="close"
                    style={{ width: '88px' }}
                    type="secondary"
                    onClick={() => {
                      if (smsSignBeforeConfirm == null || smsSignBeforeConfirm == '') {
                        LzMsg.error('唯一签名不能为空！');
                        return false;
                      }
                      Servlets('putSmssignmodify', { smsSign: smsSignBeforeConfirm }).then((res: any) => {
                          console.log('res', res);
                        if (!res.success) {
                          LzMsg.error(res.resp_msg);
                        } else {
                            setUpdateSmsSignDialog(false);
                            getListData();
                            Message.success('短信签名新建成功');
                          }
                        }).catch((e) => {
                        console.log('edddddd', e);
                        LzMsg.error('提交失败！');
                      });
                    }}
                  >确认
                  </Button>
                  <Button
                    className="close"
                    style={{ width: '88px', marginLeft: '10px' }}
                    type="normal"
                    onClick={() => {
                      setUpdateSmsSignDialog(false);
                      setSmsSignBeforeConfirm('');
                    }}
                  >取消
                  </Button>
                </div>
              </div>
            </Dialog>
          </div>
        }
      </Loading>
    </>
  );
};

export default SMSSign;
